import * as ExcelJS from 'exceljs';

import { downloadUrl } from '@utils/download';
import { IDateRange } from 'components/time-frame/types';
import { formatDate } from '@utils/date';
import { Complaint } from '../models';

export async function exportComplaintsToExcel(complaints: Complaint[], timeFrame: IDateRange) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Klachten');

  // Add headers
  worksheet.addRow(['Type', 'Inhoud', 'Order Nr', 'Klant', 'BTW Nr', 'Vervoerder', 'Datum']);

  // Style the header row
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE0E0E0' },
  };

  // Add data rows
  complaints.forEach((complaint) => {
    worksheet.addRow([
      complaint.type || '-',
      complaint.content || '-',
      complaint.order?.orderNumber || 'DRAFT',
      complaint.order?.customer?.name || '-',
      complaint.order?.customer?.vatNumber || '-',
      complaint.order?.supplier?.name || '-',
      formatDate(complaint.createdAt),
    ]);
  });

  // Auto-fit columns
  worksheet.columns.forEach((column) => {
    let maxLength = 0;
    if (column.eachCell) {
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
    }
    column.width = Math.min(Math.max(maxLength + 2, 10), 50);
  });

  // Generate Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  // eslint-disable-next-line no-restricted-globals
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);

  const startDate = timeFrame.startDate ? new Date(timeFrame.startDate).toLocaleDateString('nl-BE') : '';
  const endDate = timeFrame.endDate ? new Date(timeFrame.endDate).toLocaleDateString('nl-BE') : '';
  const filename = `klachten_${startDate}_${endDate}.xlsx`.replace(/\//g, '-');

  downloadUrl(url, { filename });
}
